// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.login-button {
  background: linear-gradient(135deg, #4f46e5, #3b82f6); /* Indigo to blue */
  color: white;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.login-button:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":";AACA;EACE,qDAAqD,EAAE,mBAAmB;EAC1E,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C","sourcesContent":["\n.login-button {\n  background: linear-gradient(135deg, #4f46e5, #3b82f6); /* Indigo to blue */\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0.75rem 2rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease-in-out;\n}\n\n.login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.login-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
